import { gql } from '@/features/graphql/generated'

export const ConfigurableProductQuery = gql(/* GraphQL */ `
    query ConfigurableProduct($id: ID) {
        product(uuid: $id) {
            ...ConfigurableProduct
        }
    }
`)
